import { render, staticRenderFns } from "./BankTransferOperationsIcon.vue?vue&type=template&id=28c2283f"
import script from "./BankTransferOperationsIcon.vue?vue&type=script&lang=ts"
export * from "./BankTransferOperationsIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports